/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_NoteInputs */

const en_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your subscription. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."`)
};

const ar_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- وصول غير محدود إلى أشجار حصرية من بلس وأشجار موسمية جديدة وأشجار كريستالية موسمية مختارة خلال فترة اشتراكك. (غير مفتوح بشكل دائم)
- أشجار حصرية من بلس محجوزة حصريًا لأعضاء بلس.
- تحديثات المحتوى الموسمية تتم في ٣١ ديسمبر، ٣١ مارس، ٣٠ يونيو، و ٣٠ سبتمبر (UTC+8)، بما في ذلك أشجار موسمية جديدة وأشجار كريستالية موسمية مختارة.
- يمكن استخدام جميع الأشجار في "ازرعوا معًا."`)
};

const de_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Unbegrenzter Zugang zu Plus Exklusive Bäume, Neue Bäume der Saison und Saisonal ausgewählte Kristallbäume während Ihres Abonnements. (nicht dauerhaft freigeschaltet)
- Plus Exklusive Bäume ist ausschließlich Plus-Mitgliedern vorbehalten.
- Saisonale Inhaltsupdates erfolgen am 31. Dez., 31. März, 30. Juni und 30. Sept. (UTC+8), einschließlich Neue Bäume der Saison und Saisonal ausgewählte Kristallbäume.
- Alle Bäume können in "Gemeinsam pflanzen" verwendet werden.`)
};

const es_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Acceso ilimitado a Árboles exclusivos Plus y Árboles de cristal de temporada seleccionados durante tu suscripción. (no desbloqueado permanentemente)
- Los Árboles exclusivos Plus están estrictamente reservados para los miembros Plus.
- Actualizaciones de contenido estacionales cada 31 de dic., 31 de mar., 30 de jun. y 30 de sep. (UTC+8), incluyendo Nuevos árboles de temporada y Árboles de cristal de temporada seleccionados.
- Todos los árboles se pueden utilizar en el modo Plantar juntos.`)
};

const fr_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Accès illimité aux Arbres exclusifs Plus, Nouveaux arbres saisonniers et Arbres premium de saison pendant votre abonnement (non débloqués de façon permanente).
- Les Arbres exclusifs Plus sont exclusivement réservés aux membres Plus.
- Nouveautés saisonnières mises à jour les 31 déc., 31 mars, 30 juin et 30 sept. (UTC+8), incluant les Nouveaux arbres saisonniers et Arbres premium de saison.
- Tous les arbres peuvent être utilisés dans « Planter ensemble ».`)
};

const it_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Accesso illimitato a Alberi esclusivi Plus, Nuovi alberi stagionali, e Selezione stagionale degli alberi di cristalli durante il tuo abbonamento. (non sbloccato in modo permanente)
- Alberi esclusivi Plus sono strettamente riservati ai membri Plus.
- Aggiornamenti stagionali dei contenuti ogni 31 dic, 31 mar, 30 giu e 30 set (UTC+8), inclusi Nuovi alberi stagionali, e Selezione stagionale degli alberi di cristalli.
- Tutti gli alberi possono essere utilizzati in "Pianta in gruppo."`)
};

const ja_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- サブスクリプション期間中、Plus限定の木、シーズン限定の新しい木、シーズン限定クリスタルツリーを無制限で利用できます（※永久アンロックではありません）。
- Plus限定の木は、Plusメンバー専用です。
- シーズンコンテンツは、毎年12月31日、3月31日、6月30日、9月30日 (UTC+8)に更新されます（シーズン限定の新しい木、シーズン限定クリスタルツリーを含む）。
- すべての木は「一緒に植える」モードで使用できます。`)
};

const ko_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- 구독 기간 동안 Plus 전용 나무, 시즌별 신규 나무, 시즌별 엄선된 크리스탈 나무 무제한 액세스 지원. (기간제)
- Plus 전용 나무는 Plus 회원 전용이에요.
- 시즌별 신규 나무, 시즌별 엄선된 크리스탈 나무 등 매년 12월 31일, 3월 31일, 6월 30일, 9월 30일(UTC+8)에 시즌 콘텐츠가 업데이트돼요.
- 모든 나무는 "함께 심기"에서 심을 수 있어요.`)
};

const pt_br_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Acesso ilimitado a Árvores exclusivas Plus, Novas árvores sazonais e Árvores sazonais de Cristais do Tempo durante sua assinatura (não fica desbloqueado permanentemente).
- As Árvores exclusivas Plus são estritamente reservadas para os membros Plus.
- O conteúdo sazonal é atualizado sempre em 31/12, 31/03, 30/06 e 30/09 (UTC+8), incluindo Novas árvores sazonais e Árvores sazonais de Cristais do Tempo.
- Todas as árvores podem ser usadas no modo "Plantar juntos".`)
};

const ru_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Неограниченный доступ к Эксклюзивным деревьям Plus, Новым сезонным деревьям и Сезонным кристальным деревьям на выбор на время действия подписки (не является разблокировкой навсегда).
- Эксклюзивные деревья Plus доступны только пользователям Plus.
- Сезонный контент обновляется 31 декабря, 31 марта, 30 июня и 30 сентября (UTC+8), включая Новые сезонные деревья и Сезонные кристальные деревья на выбор.
- Все деревья можно использовать с функцией «Сажать вместе».`)
};

const th_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- เข้าถึงต้นไม้สุดพิเศษสำหรับ Plus ต้นไม้ใหม่ประจำฤดูกาล และต้นไม้คริสตัลที่คัดสรรตามฤดูกาลอย่างไม่จำกัดตลอดการสมัครสมาชิกของคุณ (ไม่ได้ปลดล็อกถาวร)
- ต้นไม้สุดพิเศษสำหรับ Plus เปิดให้ใช้งานเฉพาะสมาชิก Plus เท่านั้น
- เนื้อหาตามฤดูกาลจะมีการอัปเดตทุกวันที่ 31 ธ.ค., 31 มี.ค., 30 มิ.ย., และ 30 ก.ย. (UTC+8) โดยรวมถึงต้นไม้ใหม่ประจำฤดูกาลและต้นไม้คริสตัลที่คัดสรรตามฤดูกาล
- ต้นไม้ทั้งหมดสามารถใช้งานได้ใน "ปลูกต้นไม้ด้วยกัน"`)
};

const tr_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Aboneliğin süresince Plus Özel Ağaçlar, Mevsimsel Yeni Ağaçlar ve Mevsimsel Seçkin Kristal Ağaçlara sınırsız erişim (kilitleri kalıcı olarak açılmaz)
- Plus Özel Ağaçlar, yalnızca Plus üyeleri için ayrılmıştır.
- Mevsimsel Yeni Ağaçlar ve Mevsimsel Seçkin Kristal Ağaçlar dahil olmak üzere her 31 Aralık, 31 Mart, 30 Haziran ve 30 Eylül'de (UTC+8) mevsimsel içerik güncellemeleri yapılır.
- Tüm ağaçlar "Birlikte ağaç dikin" modunda kullanılabilir.`)
};

const zh_cn_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Plus 会员期间，可无限使用「Plus 限定树」、「当季新树」以及「当季精选宝石树」（非永久解锁）
- Plus 限定树仅保留给 Plus 会员使用
- 季节内容会于每年 12月31日、3月31日、6月30日、9月30日 (UTC+8) 定期更新「当季新树」与「当季精选宝石树」。
- 所有树种皆可用于「多人一起种」模式`)
};

const zh_tw_content_note = /** @type {(inputs: Content_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- 訂閱期間，可無限使用「Plus 限定樹」、「當季新樹」以及「當季精選寶石樹」（非永久解鎖）
- Plus 限定樹僅保留給 Plus 訂閱用戶使用
- 季節內容會於每年 12/31、3/31、6/30、9/30 (UTC+8) 定期更新「當季新樹」與「當季精選寶石樹」。
- 所有樹種皆可用於「多人一起種」模式`)
};

/**
* | output |
* | --- |
* | "- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your subscription. (not permanently unlocked) - Plus..." |
*
* @param {Content_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const content_note = /** @type {((inputs?: Content_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_content_note(inputs)
	if (locale === "ar") return ar_content_note(inputs)
	if (locale === "de") return de_content_note(inputs)
	if (locale === "es") return es_content_note(inputs)
	if (locale === "fr") return fr_content_note(inputs)
	if (locale === "it") return it_content_note(inputs)
	if (locale === "ja") return ja_content_note(inputs)
	if (locale === "ko") return ko_content_note(inputs)
	if (locale === "pt_br") return pt_br_content_note(inputs)
	if (locale === "ru") return ru_content_note(inputs)
	if (locale === "th") return th_content_note(inputs)
	if (locale === "tr") return tr_content_note(inputs)
	if (locale === "zh_cn") return zh_cn_content_note(inputs)
	return zh_tw_content_note(inputs)
});